










import CpSubHeader from '@ui/src/components/CpSubHeader/CpSubHeader.vue'
import { defineComponent, useRouter } from '@nuxtjs/composition-api'
import useAccount from '@app/composable/useAccount'
import {
  NormalAccountResponse,
  SalonAccountResponse,
} from '../../types/src/account'
import urls from '../../plugins/urls'
export default defineComponent({
  components: {
    CpSubHeader,
  },
  setup() {
    const router = useRouter()
    const { account, isSalon } = useAccount()
    const gotoTop = () => {
      router.push(urls.mypage)
    }
    const displayName = isSalon.value
      ? (account.value as SalonAccountResponse).salon_name
      : `${(account.value as NormalAccountResponse).name_1} ${
          (account.value as NormalAccountResponse).name_2
        }`
    return {
      displayName,
      isSalon,
      gotoTop,
    }
  },
})
